<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="item" v-for="(dataListItem, index) in dataList" :key="index">
        <div class="top">
          <div class="info-row enterprise-name-row">
            <span class="label">企业名称：</span>
            <span class="enterprise-name">{{
              dataListItem.enterpriseName
            }}</span>
          </div>
          <div class="info-row">
            <span class="label">客户姓名：</span>
            <span>{{ dataListItem.customerName }}</span>
          </div>
          <div class="info-row">
            <span class="label">联系电话：</span>
            <span>{{ dataListItem.customerPhone }}</span>
          </div>
          <div class="info-row">
            <span class="label">对外报价：</span>
            <span>{{
              JSON.parse(dataListItem.plans)["司法案件"][0].serviceCost
            }}</span>
          </div>
          <div class="info-row">
            <span class="label">创建时间：</span>
            <span>{{ parseTime(dataListItem.createDateTime) }}</span>
          </div>
          <div class="info-row plans-row">
            <span class="label">司法案件：</span>
            <div class="plan">
              <span
                class="plans"
                v-for="(plans, index) in JSON.parse(
                  JSON.parse(dataListItem.plans)['司法案件'][0].items
                ).slice(0, showAllPlans[index] ? undefined : 4)"
                :key="index"
                :class="['plans-item', `plans-item-${index % 5}`]"
                >{{ index + 1 }}. {{ plans.name }}</span
              >
              <div
                class="expand-button"
                v-if="
                  JSON.parse(
                    JSON.parse(dataListItem.plans)['司法案件'][0].items
                  ).length > 4
                "
                @click="togglePlans(index)"
              >
                <span class="expand-text">
                  {{
                    showAllPlans[index]
                      ? "收起"
                      : `展开剩余 ${
                          JSON.parse(
                            JSON.parse(dataListItem.plans)["司法案件"][0].items
                          ).length - 4
                        } 条`
                  }}
                </span>
                <van-icon
                  :name="showAllPlans[index] ? 'arrow-up' : 'arrow-down'"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div @click="toCall(dataListItem.customerPhone)">
            <img
              src="https://static.xchengtech.cn/bc3a408f371f49db80b9193ed34bdfed.png"
              alt=""
            /><span>联系客户</span>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import {
  Button,
  RadioGroup,
  Radio,
  Toast,
  Notify,
  Picker,
  Form,
  Empty,
  List,
  Field,
  Dialog,
  Collapse,
  CollapseItem,
  Popover,
  Icon,
} from "vant";
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(Field);
Vue.use(Empty);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(List);
Vue.use(Form);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Icon);
import Vue from "vue";
import { parseTime } from "@/utils/index.js";
import { xcXyxf } from "@/api/xcCustomer";
export default {
  created() {},
  data() {
    return {
      query: {
        size: 10,
        page: 0,
        sort: "createDateTime,desc",
        createDateTime: [],
      },
      dataList: [],
      loading: false,
      finished: false,
      toApplyDialogShow: false,
      showAllPlans: {}, // 控制每个条目的司法案件展开状态
    };
  },
  methods: {
    getVlue(plan) {
      console.log("plan", plan);
    },
    parseTime,
    onLoad() {
      this.loading = true;
      this.getXcCustomerData();
    },
    onSearch() {
      this.query.page = 0;
      this.finished = false;
      this.loading = true;
      this.dataList = [];
      this.getXcCustomerData();
    },
    // 获取订单数据
    getXcCustomerData() {
      if (!this.query.name) delete this.query.name;
      xcXyxf(this.query)
        .then((res) => {
          this.dataList = this.dataList.concat(res.content);
          this.loading = false;
          this.query.page++;
          if (res.content.length == 0) {
            this.finished = true;
          }
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    toCall(item) {
      window.open("tel:" + item);
    },
    // 切换司法案件展开/收起状态
    togglePlans(index) {
      this.$set(this.showAllPlans, index, !this.showAllPlans[index]);
    },
  },
};
</script>

<style scoped>
.item {
  position: relative;
  padding: 2vw 4vw 3vw 4vw;
  background-color: #ffffff;
  margin-bottom: 5vw;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.item:nth-last-of-type(1) {
  margin-bottom: 0;
}
.item .top {
}
.enterprise-name-row {
}
.enterprise-name-row .label {
}
.enterprise-name-row .enterprise-name {
  max-width: 42vw;
  word-wrap: break-word;
  word-break: break-all;
  line-height: 1.4;
}
.item .top .info-row {
  display: grid;
  grid-template-columns: 20vw auto;
  padding: 2vw 0;
}
.item .top .info-row .label {
  color: #667799;
}
.item .bottom {
  position: absolute;
  top: 4vw;
  right: 4vw;
  color: #838383;
}
.item .bottom div {
  display: flex;
  align-items: center;
  gap: 1vw;
  justify-content: center;
}
.item .bottom div img {
  display: block;
  width: 4vw;
}
.plans-row {
}
.plans-row .label {
  /* padding-bottom: 1vw; */
}
.plans-row .plan {
  display: grid;
  gap: 1vw;
}

/* 司法案件项的不同背景颜色 */
.plans-item {
  padding: 2vw 3vw;
  border-radius: 8px;
  font-size: 3.5vw;
  line-height: 1.4;
  display: inline-block;
  margin-bottom: 1vw;
}

.plans-item-0 {
  background-color: #e3f2fd;
  color: #1565c0;
  border-left: 4px solid #2196f3;
}

.plans-item-1 {
  background-color: #f3e5f5;
  color: #7b1fa2;
  border-left: 4px solid #9c27b0;
}

.plans-item-2 {
  background-color: #e8f5e8;
  color: #2e7d32;
  border-left: 4px solid #4caf50;
}

.plans-item-3 {
  background-color: #fff3e0;
  color: #ef6c00;
  border-left: 4px solid #ff9800;
}

.plans-item-4 {
  background-color: #fce4ec;
  color: #c2185b;
  border-left: 4px solid #e91e63;
}

/* 展开/收起按钮样式 */
.expand-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2vw 3vw;
  margin-top: 1vw;
  background-color: #f5f5f5;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border: 1px solid #e0e0e0;
}

.expand-button:hover {
  background-color: #eeeeee;
}

.expand-text {
  font-size: 3.2vw;
  color: #666666;
  margin-right: 1vw;
  font-weight: 500;
}

.expand-button .van-icon {
  color: #666666;
  font-size: 3.2vw;
}
</style>


// WEBPACK FOOTER //
// src/view/myCustomer/module/xyxfData/index.vue